<div class='px-1'>
  <div class='UserGroupsListingMobileRow mobile-row row px-3'>
    <div [queryParams]='{"group_name": item.group_name}' [routerLink]='["/user_contacts", item.group_id, "contacts"]'
         class='mobile-row-section col col-4'>{{ item.group_name }}
    </div>
    <div [queryParams]='{"group_name": item.group_name}' [routerLink]='["/user_contacts", item.group_id, "contacts"]'
         class='mobile-row-section col col-4'>{{ item.campaign_name }}
    </div>
    <div class='mobile-row-section col col-3'>
      <app-total-active-column [active]='item.active_contacts' [groupId]='item.group_id' [groupName]='item.group_name'
                               [total]='item.total_contacts'></app-total-active-column>
    </div>
    <div class='mobile-row-section col col-1'>
      <app-menu-button [properties]='menuItems'
                       [target]='item'></app-menu-button>
    </div>
  </div>
</div>